import { render } from "./PersonalCenter.vue?vue&type=template&id=4c86893e&scoped=true"
import script from "./PersonalCenter.vue?vue&type=script&lang=js"
export * from "./PersonalCenter.vue?vue&type=script&lang=js"

import "./PersonalCenter.vue?vue&type=style&index=0&id=4c86893e&lang=less&scoped=true"

import exportComponent from "D:\\cwzl\\four-cw-net\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c86893e"]])

export default __exports__